module.exports = "<div class=\"btn-group\">\n\t<button data-toggle=\"dropdown\" class=\"btn btn-sm btn-primary dropdown-toggle\">\n\t\t{{settings.label}} <span class=\"ace-icon fa fa-caret-down icon-on-right\"></span>\n\t</button>\n\t<ul class=\"dropdown-menu dropdown-info\">\n\t\t<li *ngFor=\"let btn of settings.buttons\">\n\t\t\t<a [routerLink]=\"btn.href\" [queryParams]=\"btn.queryParams\" (click)=\"onClick($event, btn);\">\n\t\t\t\t{{btn.label}}\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/dropdown-button/dropdown-button.html
// module id = 529
// module chunks = 0